import { YearsMonthsTranslation } from '@/assets/locales/util/yearsMonths/yearsMonths.translation.pl.ts';

export const yearsMonthsTranslation: YearsMonthsTranslation = {
  months_one: '{{count}} month',
  months_other: '{{count}} months',
  years_one: '{{count}} year',
  years_other: '{{count}} years',
};
